import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { FAQ } from '../components/FAQ';
import { WhatThisIsNot } from '../components/WhatThisIsNot';
import { FinalCTA } from '../components/FinalCTA';
export function PreguntasPage() {
  return <>
      <PageHeader eyebrow="Para que llegues con claridad" title="Preguntas frecuentes" data-id="element-557" />
      <FAQ data-id="element-558" />
      <WhatThisIsNot data-id="element-559" />
      <FinalCTA data-id="element-560" />
    </>;
}